var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 672,
    viewBox: "0 0 375 672",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67363_81039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H363C369.627 0 375 5.37258 375 12V672H0V12Z",
    fill: "url(#paint0_linear_67363_81039)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 361.732,
    cy: 103.73,
    r: 80,
    transform: "rotate(0.524908 361.732 103.73)",
    fill: "url(#paint1_linear_67363_81039)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 236.275,
    cy: 225.273,
    r: 110.904,
    transform: "rotate(-0.712859 236.275 225.273)",
    fill: "url(#paint2_linear_67363_81039)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1977,
    cy: 184.196,
    r: 80,
    transform: "rotate(-18.4404 39.1977 184.196)",
    fill: "url(#paint3_linear_67363_81039)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67363_81039",
    x1: 305.597,
    y1: 47.324,
    x2: -139.974,
    y2: 91.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997985,
    stopColor: "#38287C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67363_81039",
    x1: 361.732,
    y1: 23.7295,
    x2: 361.732,
    y2: 183.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_67363_81039",
    x1: 236.275,
    y1: 114.369,
    x2: 236.275,
    y2: 336.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_67363_81039",
    x1: 39.1977,
    y1: 104.196,
    x2: 39.1977,
    y2: 264.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67363_81039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H363C369.627 0 375 5.37258 375 12V672H0V12Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBg);
export default __webpack_public_path__ + "static/media/ModalBg.ad096bca4852b5c17f5e0f89e22403dd.svg";
export { ForwardRef as ReactComponent };